import React from 'react';
import { TypedMemo } from '../../../common/types';
import { ServiceConnection } from '../../../../redux/api/fymAPI.types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for ConnectionCardPortal; each part uses its own slice of it */
import styles from '../ConnectionCardPortal.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The SoundCloud profile of a stored login (design a2 states 3 and 4): the avatar and the name. */
const SoundCloudCardProfileComponent: React.FC<{ connection: ServiceConnection }> = ({ connection }) => {
  const { artist } = connection;
  if (artist === null) {
    return null;
  }
  return (
    <div className={styles.connectionPortal}>
      <div className={styles.connectionArtist}>
        {artist.imageUrl !== null && artist.imageUrl !== '' && (
          <img src={artist.imageUrl} alt="" className={styles.connectionAvatar} />
        )}
        <span>{artist.name}</span>
      </div>
    </div>
  );
};

export const SoundCloudCardProfile = TypedMemo(SoundCloudCardProfileComponent);
